import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-document-form',
  templateUrl: './invoice-document-form.component.html',
  styleUrls: ['./invoice-document-form.component.scss']
})
export class InvoiceDocumentFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
